// /////////////////////////////////////////////////////////////
// [ファイル] AccountingAssistantDialog.tsx
// [概要] 月次合計試算表ページから開く「会計 AI アシスタント」モーダル。
//        Genkit 駆動の AI アシスタント (会計モード) を WorkspaceAssistantPanel で表示し、
//        OBC 仕訳の起票ゆれ検知・補助元帳の照会・要約・自由質問に会話形式で答える。
//        会話一覧は agentType='accounting' で GWS アシスタントと分離する。
// /////////////////////////////////////////////////////////////
import React from 'react';
import { Dialog, DialogTitle, DialogContent, Box, Typography, IconButton } from '@mui/material';
import * as Icons from '../../constants/icons';
import WorkspaceAssistantPanel from '../WorkspaceAssistantPanel';

// 会計用途の例文 (空状態のとき表示)
const ACCOUNTING_EXAMPLES = [
  '2026年度12月の接待交際費の起票のゆれを教えて',
  '水道光熱費(7130G)の2026年度11月の仕訳明細を見せて',
  '2026年度の補助科目の付け間違いが疑われる起票を一覧して',
  '同じ取引先なのに補助科目が割れている起票を探して',
];

type Props = {
  open: boolean;
  onClose: () => void;
};

export default function AccountingAssistantDialog({ open, onClose }: Props) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{ sx: { borderRadius: '14px', height: '88vh' } }}
    >
      <DialogTitle sx={{ p: 2, pb: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box sx={{ display: 'flex', p: 0.7, borderRadius: '8px', backgroundColor: '#eff6ff', color: '#3b82f6' }}>
            <Icons.AutoAwesome sx={{ fontSize: '22px' }} />
          </Box>
          <Box>
            <Typography sx={{ fontWeight: 800, color: '#1e293b', fontSize: '16px', lineHeight: 1.2 }}>
              会計 AI アシスタント
            </Typography>
            <Typography sx={{ fontSize: '12.5px', color: '#64748b' }}>
              OBC 仕訳の起票ゆれ検知・補助元帳の照会・要約に答えます（会計年度は9〜8月）
            </Typography>
          </Box>
        </Box>
        <IconButton onClick={onClose} size="small"><Icons.Close fontSize="small" /></IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 0, overflow: 'hidden' }}>
        {/* ダイアログ内に収めるため高さを上書き (タイトル分を差し引く) */}
        <WorkspaceAssistantPanel
          agentType="accounting"
          fixedMode="accounting"
          examplePrompts={ACCOUNTING_EXAMPLES}
          emptyStateText="OBC 仕訳の起票ゆれ検知や補助元帳の照会を依頼できます。例えば…"
          height="calc(88vh - 96px)"
        />
      </DialogContent>
    </Dialog>
  );
}
